import axios from 'axios';

let baseUrl = '';
if (process.env.NODE_ENV === 'production') {
  baseUrl = 'https://novanet-app-paskenotter-prod.azurewebsites.net/';
} else {
  baseUrl = 'https://localhost:7290/';
}

export default axios.create({
  baseURL: baseUrl
});



// WEBPACK FOOTER //
// ./src/utils/http-common.js